// extracted by mini-css-extract-plugin
module.exports = {"Section___margined":"ContentSection_Section___margined__3az2P","Section___centered":"ContentSection_Section___centered__J0ACY"};